import { render, staticRenderFns } from "./RelatedBusinessCell.vue?vue&type=template&id=a8947b0e&scoped=true"
import script from "./RelatedBusinessCell.vue?vue&type=script&lang=js"
export * from "./RelatedBusinessCell.vue?vue&type=script&lang=js"
import style0 from "./RelatedBusinessCell.vue?vue&type=style&index=0&id=a8947b0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8947b0e",
  null
  
)

export default component.exports